import { instance } from '../instance';

export const getExceptionList = (param) => instance.post('exception/list', param);
